<template>
  <Loading v-if="!resolved" class="mt-10" />
  <component :is="selectionComponent" v-else />
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { Loading } from '@/components'
import Selection from '@/views/Selection.vue'
import loadV2Selection from '@/utils/loadV2Selection'

const V2Selection = defineAsyncComponent(loadV2Selection)

export default {
  components: {
    Loading,
    Selection,
    V2Selection
  },

  data() {
    return { infoSettled: false }
  },

  computed: {
    resolved() {
      return this.infoSettled && !!this.$store.getters.info
    },
    selectionComponent() {
      return this.$store.getters.hasV2Checkout ? V2Selection : Selection
    }
  },

  async mounted() {
    await this.$store.dispatch('getInfo').catch(() => null)
    this.infoSettled = true
  }
}
</script>
